<template>
  <div class="mx-3">
    <h1 class="py-md-6">
      {{ $t("viewCalendar.title") }}
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            class="ml-1 green-shadow"
            x-small
            fab
            max-width="26"
            max-height="26"
            v-on="on"
            :title="$t('common.add')"
          >
            <v-icon x-small>$plus</v-icon>
          </v-btn>
        </template>
        <v-list offset-y>
          <v-list-item>
            <v-list-item-title
              class="pointer"
              @click="
                customer = {};
                customerId = null;
                customerEditForm = true;
              "
            >
              {{ $t("viewOrders.order_for_new_customer") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="pointer" @click="customerFindForm = true">
              {{ $t("viewOrders.order_for_exist_customer") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </h1>

    <v-card class="mb-2 pa-1 elevation-0">
      <v-row class="pa-2 ma-0">
        <v-flex ma-0 pa-0>
          <v-btn color="primary" class="mr-3" elevation="0" @click="setToday">
            {{ $t("viewCalendar.today") }}
          </v-btn>
          <v-btn fab elevation="0" small @click="$refs.calendar.prev()">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-menu
            v-if="$refs.calendar"
            v-model="calendarDatePickerVisible"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <span class="dashed mx-4">
                {{ $moment(currentCalendarDate).format("DD.MM.YYYY") }}
                </span>
              </span>
            </template>
            <v-date-picker
              :first-day-of-week="first_day_of_week"
              v-model="calendarDate"
              @input="calendarDatePickerVisible = false"
              :locale="locale"
            >
            </v-date-picker>
          </v-menu>
          <v-btn fab elevation="0" small @click="$refs.calendar.next()">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-progress-circular
            indeterminate
            size="20"
            color="primary"
            v-if="!fetched"
          ></v-progress-circular>
        </v-flex>
      </v-row>
    </v-card>
    <v-row class="fill-height">
      <v-col class="py-0">
        <v-sheet
          style="overflow-x: scroll"
          :class="{ calendarIsLoading: !fetched }"
        >
          <v-calendar
            style="min-width: 1400px"
            :first-time="calendarDayStartTime"
            :interval-count="calendarIntervalCount"
            weekdays="[1, 2, 3, 4, 5, 6, 0]"
            :locale="locale"
            ref="calendar"
            v-model="calendarDate"
            color="primary"
            type="category"
            category-show-all
            :categories="categories"
            :events="allIntervals"
            :event-color="getEventColor"
            @mousedown:time-category="selectTimeToAttachRepairtime"
            @mousedown:event="startDrag"
            @mousedown:time="startTime"
            @mousemove:time-category="mouseMove"
            @mouseup:time="endDrag"
          >
            <template #category="{ category }">
              <div class="text-center d-flex justify-center align">
                <img class="px-1" v-if="posts && posts.find(
                      (current) => current.name === category
                  ) && posts.find(
                      (current) => current.name === category
                  ).post_icon" height="20" :src="postIconPath + posts.find(
                      (current) => current.name === category
                  ).post_icon.file"/>
                <span>{{ category }}</span>
                <v-icon
                  :title="$t('viewCalendar.post_is_disabled')"
                  x-small
                  color="error"
                  v-if="
                    posts.find((current) => current.name === category).active !=
                    1
                  "
                  >fa-ban</v-icon
                >
              </div>
            </template>
            <template #day-label-header="{ date, week }">
              <span></span>
            </template>
            <template #day-body="{ date, week }">
              <div
                  v-if="isTodayCurrentCalendarDate"
                class="v-current-time"
                :class="{ first: date === week[0].date }"
                :style="{ top: nowY }"
              ></div>
            </template>
            <template #event="{ event, eventParsed }">
              <div class="eventWrap black--text" :style="{'min-height':(ready ? cal.minutesToPixels(event.duration) : 0)+'px'}">
                <div class="d-flex">
                  <span
                      :title="timeTitle(eventParsed)"
                      class="darken-1 blue-grey white--text rounded-sm px-1"
                  >
                    {{ timeForShow(eventParsed) }}
                  </span>
                  <span
                      class="mx-2 pointer dashed text-no-wrap d-block"
                      @click.stop="showAttachDialogForExistEvent(event)"
                  >
                    <span
                        :style="{ background: event.status_color }"
                        class="d-inline-block eventStatusColor"
                    ></span>
                    #{{ event.order_human_number }}
                  </span>
                  <img
                      v-if="!!brandURL(event.brand)"
                      class="brandLogo"
                      :src="brandURL(event.brand)"
                      :title="event.brand.toUpperCase()"
                  />
                  <span
                      class="brandWithoutLogo mr-3"
                      :title="event.brand === 'none' ? undefined : event.brand && event.brand.toUpperCase()"
                      v-else
                  >
                    {{ event.brand && event.brand.toUpperCase().slice(0, 1) }}
                  </span>
                  <beauty-car-number
                      v-if="event.car_number"
                      :number="event.car_number"
                      class="small d-inline-block mx-1"
                  />
                  <user-profile-photo :title="event.repairer.name" class="mr-1" v-if="event.repairer" :profile-photo="event.repairer.profile_photo" :size="18"></user-profile-photo>
                </div>
                <div class="repairtimeName" :title="event.repairtime_name">{{
                    event.repairtime_name
                  }}
                </div>
              </div>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="customerFindForm" scrollable max-width="500">
      <customerFindForm
        @select="
          (data) => {
            goToSearchWithCustomer(data);
          }
        "
        :visible="customerFindForm"
      ></customerFindForm>
    </v-dialog>
    <v-dialog v-model="customerEditForm" scrollable max-width="890">
      <customerForm
        @removed="customerEditForm=false"
        :is-visible="customerEditForm"
        @store="
          (data) => {
            $store.dispatch('customers/get');
            customerId = data.id;
            customerEditForm = false;
            customerEditForm = true;
          }
        "
        :customer-id="customerId"
      ></customerForm>
    </v-dialog>
    <v-dialog
      v-model="attachDialog.visible"
      scrollable
      max-width="800"
      persistent
    >
      <v-card
        :loading="
          (savingInProgress || !isFetchedOrder) &&
          (Object.keys(order) != [] || !!order)
        "
      >
        <v-card-actions>
          <!--Прикрепление-->
          <h3 class="pl-2">{{ $t("common.attaching")}}<span v-if="this.attachDialog.category">: {{ this.attachDialog.category }}</span>
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="attachDialog.hideAndClear();order = {};">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4 pt-0">
          <v-row
            v-if="!attachDialog.order && attachDialog.visible"
            class="mt-6"
          >
            <v-col cols="5">
              <date-time-picker
                v-if="ready"
                outlined
                :date-label="$t('viewCalendar.start_date')"
                :time-label="$t('viewCalendar.start_time')"
                :date.sync="attachDialog.date"
                :time.sync="attachDialog.time"
                :min-date="todayDate"
                :min-time="
                  attachDialog.date != cal.times.now.date
                    ? undefined
                    : cal.times.now.time
                "
              />
            </v-col>
            <v-col cols="7" class="pl-0">
              <v-autocomplete
                outlined
                @change="selectOrderInAutocomplete"
                :items="findedOrders"
                :loading="isFindingOrders"
                clearable
                hide-no-data
                :item-text="autocompleteItemText"
                :search-input.sync="findOrderString"
                :label="$t('viewCalendar.search_exist_order')"
                :placeholder="$t('common.start_typing_to_search')"
                prepend-inner-icon="mdi-database-search"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>
          <template v-if="order && order.human_number">
            <h3>
              {{ $t("common.order") }} №
              <span
                class="mr-2 pointer dashed"
                @click.stop="orderWindow.orderId = order.id;orderWindow.isVisible = true;"
                >{{ order.human_number }}</span
              >
              <v-btn
                v-if="attachDialog.date"
                icon
                @click="
                  attachDialog.clearOrder();
                  order.human_number = null;
                "
                class="mr-2"
              >
                <v-icon small>fa-times</v-icon>
              </v-btn>
            </h3>
            <v-select
              class="no-line-select"
              hide-details
              :items="order_statuses"
              :label="$t('viewOrdersForm.status')"
              item-text="name"
              return-object
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              v-model="order.status"
            >
              <template v-slot:selection="{ item }">
                <span class="text-no-wrap">
                  <span
                    :style="{
                      background: item.color,
                      color: getCorrectTextColor(item.color),
                    }"
                    class="pa-1 d-inline-block mr-1 status-square"
                  ></span>
                  {{
                    item.system
                      ? $t("common.orderSystemStatusNames." + item.name)
                      : item.name
                  }}
                </span>
              </template>
              <template v-slot:item="{ item }">
                <span
                  :style="{
                    background: item.color,
                    color: getCorrectTextColor(item.color),
                  }"
                  class="pa-1 d-block mr-2 status-square"
                ></span>
                {{
                  item.system
                    ? $t("common.orderSystemStatusNames." + item.name)
                    : item.name
                }}
              </template>
            </v-select>
            <p class="ma-0" v-if="order.customer.is_company == 1">
              {{ $t("common.legal_name") }}:
              <strong>{{
                order.customer.is_company == 1
                  ? "[" + order.customer.legal_name + "]"
                  : ""
              }}</strong>
            </p>
            <p class="ma-0">
              {{ $t("common.customer") }}:
              <strong
                >{{ order.customer.last_name }} {{ order.customer.first_name }}
                {{ order.customer.patronymic ? order.customer.patronymic : "" }}
              </strong>
            </p>
            <p class="ma-0">
              {{ $t("common.customer_type") }}:
              <strong>{{
                order.customer.customer_type
                  ? order.customer.customer_type.name
                  : "-"
              }}</strong>
            </p>
            <p class="ma-0">
              {{ $t("common.phone") }}:
              <strong>{{ order.customer.phone }}</strong>
            </p>
            <p class="ma-0">
              {{ $t("common.email") }}:
              <strong
                ><a :href="'mailto:' + order.customer.email">{{
                  order.customer.email
                }}</a></strong
              >
            </p>
            <p class="ma-0">
              {{ $t("common.car") }}:
              <strong>
                {{ order.car ? order.car.name : ""
                }}<beauty-car-number
                  v-if="order.car && order.car.car_number"
                  :number="order.car.car_number"
                ></beauty-car-number>
                <span v-if="!order.car">{{ $t("common.not_selected") }}</span>
              </strong>
            </p>
            <p class="ma-0">
              {{ $t("viewOrders.tableHeader.created_at") }}:
              <strong>{{ order.created_at | moment("DD.MM.YYYY HH:mm") }}</strong>
            </p>
            <p class="ma-0">
              {{ $t("viewOrders.tableHeader.total_sum") }}:
              <strong
                >{{
                  formatCurrency(Object.values(this.order.items)
                    .reduce((sum, item) => item.price * item.amount + sum, 0)
                    .toFixed(2))
                }}
              </strong>
            </p>
            <!--- list of repairtimes -->
            <h3 v-if="order.items && order.items.length > 0">
              {{ $t("viewCalendar.repairtimes") }}:
            </h3>

            <div
              class="drag-container"
              v-drag-and-drop:options="{
                dropzoneSelector: '.drag-inner-list',
                draggableSelector: '.drag-item',
                onDrop: recountIntervalDates,
              }"
            >
              <vue-draggable-group v-model="allRepairtimesOfOrder" :groups="[]">
                <div class="drag-inner-list">
                  <v-card
                    elevation="1"
                    :data-id="oneRepairtime.id"
                    v-if="oneRepairtime.item_type === 'repairtime'"
                    v-for="oneRepairtime in allRepairtimesOfOrder.sort(
                      compareRepairtimesDateForSort
                    )"
                    class="drag-item pa-2 mb-3 pb-0"
                    :key="oneRepairtime.id"
                  >
                    <v-icon x-small>fa-tools</v-icon> {{ oneRepairtime.name }}
                    <i v-if="oneRepairtime.amount > 1"
                      >(x{{ oneRepairtime.amount }})</i
                    >
                    <v-container class="pa-0 ma-0">
                      <v-row>
                        <v-col cols="4" class="pb-0">
                          <v-select
                            outlined
                            v-if="oneRepairtime.interval"
                            :label="$t('common.post')"
                            :items="posts"
                            return-object
                            item-text="name"
                            v-model="oneRepairtime.interval.post"
                            class="pointer"
                          ></v-select>
                        </v-col>
                        <v-col cols="8" class="theme--light pb-0">
                          <date-time-picker
                            v-if="ready"
                            outlined
                            :date-label="$t('viewCalendar.start_date')"
                            :time-label="$t('viewCalendar.start_time')"
                            :min-date="todayDate"
                            :min-time="
                              attachDialog.date != cal.times.now.date
                                ? undefined
                                : cal.times.now.time
                            "
                            :date-time="
                              oneRepairtime.interval &&
                              oneRepairtime.interval.start
                            "
                            @change="
                              (start) => {
                                changeRepairtimeIntervalDate(
                                  start,
                                  oneRepairtime
                                );
                              }
                            "
                          />
                        </v-col>
                      </v-row>
                      <v-row class="pa-0">
                        <v-col cols="4" class="pt-0">
                          <v-text-field
                            outlined
                            v-model="oneRepairtime.duration"
                            @change="
                              changeRepairtimeIntervalDate(
                                oneRepairtime.interval.start,
                                oneRepairtime
                              )
                            "
                            :label="$t('viewCalendar.plan_time_in_minutes')"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pt-0 pr-0">
                          <v-select
                            outlined
                            :label="$t('viewCalendar.repairer')"
                            :items="users"
                            v-if="oneRepairtime.interval"
                            @change="
                              (data) => {
                                autofillEmptyRepairerInRepairtimes(data);
                              }
                            "
                            item-text="name"
                            return-object
                            v-model="oneRepairtime.interval.repairer"
                            class="pointer"
                            clearable
                          ></v-select>
                        </v-col>
                        <v-col cols="4" class="pt-0">
                          <!-- статус работы -->
                          <v-select
                            class="no-line-select"
                            outlined
                            xs6
                            hide-details
                            :items="order_repairtimes_statuses"
                            :label="$t('viewOrdersForm.status_repairtime')"
                            item-text="name"
                            return-object
                            :rules="[
                              (v) =>
                                !!v ||
                                $t('form.validationErrors.field_is_required'),
                            ]"
                            v-model="oneRepairtime.status"
                          >
                            <template v-slot:selection="{ item }">
                              <span class="text-no-wrap">
                                <span
                                  :style="{
                                    background: item.color,
                                    color: getCorrectTextColor(item.color),
                                  }"
                                  class="pa-1 d-inline-block mr-1 status-square"
                                ></span>
                                {{
                                  item.type === "shop_order_repairtime_status"
                                    ? item.name
                                    : $t(
                                        "common.orderPartsSystemStatusNames." +
                                          item.name
                                      )
                                }}
                              </span>
                            </template>
                            <template v-slot:item="{ item }">
                              <span
                                :style="{
                                  background: item.color,
                                  color: getCorrectTextColor(item.color),
                                }"
                                class="pa-1 d-block mr-2 status-square"
                              ></span>
                              {{
                                item.type === "shop_order_repairtime_status"
                                  ? item.name
                                  : $t(
                                      "common.orderPartsSystemStatusNames." +
                                        item.name
                                    )
                              }}
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </div>
              </vue-draggable-group>
            </div>
          </template>
          <v-divider class="mt-4"></v-divider>
          <v-card-actions class="mt-5 px-0 mx-0">
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              color="red"
              class="white--text"
              @click="attachDialog.hideAndClear();order = {};"
            >
              {{
                $t("common.cancel")
              }}
            </v-btn>
            <v-btn
                v-if="order && order.human_number"
                class="float-right white--text"
                elevation="0"
                color="primary"
                :loading="savingInProgress"
                :disabled="savingInProgress"
                @click="saveAttachedForOrderRepairtimesIntervals"
                @keyup.enter="saveAttachedForOrderRepairtimesIntervals"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <order-window
        :is-visible="orderWindow.isVisible"
        :order-id="orderWindow.orderId"
        @hide="orderWindow.orderId=null; orderWindow.isVisible=false;"
        @update="(data)=>order=data"
    />
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import CalendarMixin from "@/mixins/calendar";
import BeautyCarNumber from "../../components/common/BeautyCarNumber";
import DateTimePicker from "@/components/common/DateTimePicker";
import CustomerForm from "@/components/customer/CustomerForm";
import CustomerFindForm from "@/components/customer/CustomerFindForm";
import UserProfilePhoto from "@/components/user/UserProfilePhoto";
import OrderWindow from "@/components/order/OrderWindow.vue";

export default {
  components: {
    OrderWindow,
    UserProfilePhoto,
    CustomerFindForm,
    CustomerForm,
    DateTimePicker,
    BeautyCarNumber,
  },
  mixins: [CommonMixin, CalendarMixin],
  data: () => ({
    customer: {},
    customerId: null,
    customerEditForm: null,
    customerFindForm: null,
    calendarDatePickerVisible: false,
    needSave: false,
    ready: false,
    calendarDate: "",
    todayDate: null,
    dragInterval: null,
    dragTime: null,
    order:{},
    orderWindow:{
      isVisible:false,
      orderId:null
    },
    attachDialog: {
      findTimeoutId: null,
      visible: false,
      timePickerVisible: false,
      datePickerVisible: false,
      date: null,
      time: null,
      order: null,
      category: null,
      clearOrder: function () {
        this.findedOrders = [];
        this.order = null;
        this.timePickerVisible = false;
        this.datePickerVisible = false;
      },
      hideAndClear: function () {
        this.findedOrders = [];
        this.order = null;
        this.date = null;
        this.category = null;
        this.time = null;
        this.timePickerVisible = false;
        this.datePickerVisible = false;
        this.visible = false;
      },
    },
    isShownErrorOnPastTime: false,
  }),
  mounted() {
    this.order.human_number = null;
    this.order.id = null;
    let today = new Date();
    let day = today.getDate()<10 ? '0'+String(today.getDate()) : today.getDate();

    this.todayDate = `${today.getFullYear()}-${
        today.getMonth() + 1 < 10 ? 0 : ""
    }${today.getMonth() + 1}-${day}`;
    this.calendarDate = this.todayDate;
    this.$store.dispatch("posts/get");
    this.$store.dispatch("users/get");
    this.$store.dispatch("statuses/statusesGet");
    this.ready = true;
    this.scrollToTime();
    this.updateTime();
    this.$refs.calendar.checkChange();
  },
  computed: {
    /**
     * Время начала работы в текущий(this.calendarDate) день
     */
    calendarDayStartTime(){            
      return this.getShopDayStartByDate(this.calendarDate)
    },
    /**
     * Продолжительность рабочего дня в часах, округлено в большую сторону
     */
    calendarIntervalCount(){
      const workingHours = this.authenticatedUser.shop.working_hours;
      const dayName = this.getDayNameByDate(this.calendarDate);
      const startTime = workingHours[`${dayName}_start`];      
      const endTime = workingHours[`${dayName}_end`];      
      const startDateTime = new Date(this.calendarDate+"T"+startTime);
      const endDateTime = new Date(this.calendarDate+"T"+endTime);
      
      const intervalInMilliseconds = endDateTime.getTime() - startDateTime.getTime();
      const intervalInSeconds = intervalInMilliseconds / 1000;
      const intervalInMinutes = intervalInSeconds / 60;
      const intervalInHours = intervalInMinutes / 60;
      return Math.ceil(intervalInHours);
    },     
    ...mapFields("auth", ["authenticatedUser"]),
    ...mapFields("users", ["users"]),
    ...mapFields("orders", [
      "isFetchedOrder",
      "findOrderString",
      "findedOrders",
      "isFindingOrders",
      "savingInProgress",
    ]),
    ...mapFields("posts", ["posts"]),
    ...mapFields("intervals", ["intervals", "fetched"]),
    ...mapFields("statuses", [
      "order_statuses",
      "order_repairtimes_statuses",
      "order_payments_statuses",
    ]),
    isTodayCurrentCalendarDate() {
        let calend = this.ready &&
            this.$refs.calendar &&
            this.$refs.calendar.parseTimestamp(this.$refs.calendar.value);

      let calendDate = calend ? calend.date : null;
      let todayDate = (new Date()).toISOString().split('T')[0] === calendDate;

      return todayDate
    },
    currentCalendarDate() {
      let val =
        this.$refs.calendar &&
        this.$refs.calendar.parseTimestamp(this.$refs.calendar.value);
      return val && val.date;
    },
    allIntervals() {
      let intervals = this.intervals.map((current) => {
        let brand =
          (current.repairtime &&
            current.repairtime.order &&
            current.repairtime.order.car &&
            current.repairtime.order.car.brand) ||
          "none";
        let car_number =
          (current.repairtime &&
            current.repairtime.order &&
            current.repairtime.order.car &&
            current.repairtime.order.car.car_number) ||
          null;
        let order_human_number =
          (current.repairtime &&
            current.repairtime.order &&
            current.repairtime.order.human_number) ||
          null;
        let order_id =
          (current.repairtime &&
            current.repairtime.order &&
            current.repairtime.order.id) ||
          null;
        let repairtime_name =
          (current.repairtime && current.repairtime.name) || null;
        let start =
          typeof current.start === "string"
            ? Date.parse(current.start)
            : current.start;
        let status_color =
          (current.repairtime &&
            current.repairtime.status &&
            current.repairtime.status.color) ||
          null;
        return {
          id: current.id,
          start: current.start,
          end: current.end,
          duration: current.repairtime && current.repairtime.duration || 0,
          color:
            start < Date.now()
              ? "blue-grey lighten-4 past"
              : "blue-grey lighten-4",
          timed: true,
          category: current.post.name,
          brand: brand,
          car_number: car_number,
          order_human_number: order_human_number,
          order_id: order_id,
          repairtime_name: repairtime_name,
          repairer: current.repairer,
          status_color: status_color,
        };
      });
      return intervals;
    },
    allRepairtimesOfOrder: {
      get() {
        let repairtimes = this.order.items.filter((item) => {
          return item.item_type === "repairtime";
        });
        return repairtimes.map((item) => {
          if (!item.duration && !item.interval) {
            let the_15_min_in_ms = 900000;
            let repairtimeDurationInMilliseconds = Math.round(
              item.amount * item.time * 60 * 60 * 1000
            );
            repairtimeDurationInMilliseconds =
              repairtimeDurationInMilliseconds < the_15_min_in_ms
                ? the_15_min_in_ms
                : repairtimeDurationInMilliseconds;
            item.duration = Math.round(
              repairtimeDurationInMilliseconds / 1000 / 60
            );
            item.duration = Math.ceil(item.duration / 15) * 15; //округлим полученное до 15 минут
          }
          if (!item.duration && item.interval) {
            item.duration =
              (Math.ceil(
                (Date.parse(item.interval.end) -
                  Date.parse(item.interval.start)) /
                  60000
              ) /
                15) *
              15;
          }
          return item;
        });
      },
      set(items) {
        let parts = this.order.items.filter((item) => {
          return item.item_type !== "repairtime";
        });
        this.order.items = items.concat(parts);
      },
    },
    categories() {
      return this.posts.map((current) => {
        return current.name;
      });
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + "px" : "-10px";
    },
  },
  watch: {
    "attachDialog.visible"(isVisible) {
      if (isVisible) {
        this.findedOrders = [];
      }
    },
    findOrderString() {
      clearTimeout(this.attachDialog.findTimeoutId);
      this.attachDialog.findTimeoutId = setTimeout(() => {
        this.$store.dispatch("orders/find", {
          sortBy: "human_number",
          sortDesc: "false",
        });
      }, 1000);
    },
    calendarDate(to, from) {
      this.$store.dispatch("intervals/get", { date: to });
    },
  },
  methods: {
    getShopDayStartByDate(date){
      let workingHours = this.authenticatedUser.shop.working_hours;
      let dayName = this.getDayNameByDate(date);
      return workingHours[`${dayName}_start`];
    },
    getDayNameByDate(dateString){
      const daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      const date = new Date(dateString);
      return daysOfWeek[date.getDay()];      
    },
    selectOrderInAutocomplete(data) {
      if (!data) return;
      if (
        !data.items ||
        !data.items.some((item) => item.item_type === "repairtime")
      ) {
        this.$error(
          this.$t("viewCalendar.order_doesnt_have_attached_repairtimes")
        );
        this.order.human_number = null;
        this.findOrderString = "";
        return;
      }
      this.attachDialog.order = data;
      this.showAttachDialog();
    },
    async prepareIntervals() {
      if (this.attachDialog.order && this.attachDialog.order.id) {
        await this.$store
          .dispatch("orders/orderShow", { id: this.attachDialog.order.id })
          .then((order) => {
            this.order = order;
          })
          .then(() => {
            let startDate;
            let category;
            if (this.attachDialog.category) {
              category = this.attachDialog.category;
            }
            if (this.attachDialog.date) {
              startDate = new Date(
                Date.parse(
                  `${this.attachDialog.date} ${this.attachDialog.time}`
                )
              );
            } else {
              startDate = new Date();
            }
            for (let i in this.order.items) {
              if (
                this.order.items[i].item_type === "repairtime" &&
                this.order.items[i].interval &&
                !category &&
                this.order.items[i].interval.post
              ) {
                category = this.order.items[i].interval.post.name;
              }
              if (
                this.order.items[i].item_type === "repairtime" &&
                !this.order.items[i].interval
              ) {
                let endDate = new Date(startDate);
                endDate.setMinutes(
                  startDate.getMinutes() +
                    parseInt(this.order.items[i].duration)
                );
                this.order.items[i].interval = {
                  order_item_id: this.order.id,
                  start: startDate,
                  end: endDate,
                  timed: true,
                  category: category,
                  post: this.posts.filter(
                    (current) => current.name === category
                  )[0],
                  order_id: this.order.id,
                  repairer: this.order.items[i].repairer,
                };
                startDate = endDate; //startDate для следующего элемента
              }
            }
          });
      } else {
        this.order = {};
      }
    },
    showAttachDialog() {
      this.attachDialog.visible = true;
      this.prepareIntervals();
    },
    recountIntervalDates(event, repairtime) {
      let id;
      if (event && event.items) {
        id = event.items[0].attributes["data-id"].value; //элемент который мы перетащили
      }
      let minDate;
      let intervalWithMaxDate;
      for (let i in this.allRepairtimesOfOrder) {
        minDate =
          !minDate ||
          Date.parse(minDate) >
            Date.parse(this.allRepairtimesOfOrder[i].interval.start)
            ? this.allRepairtimesOfOrder[i].interval.start
            : minDate; //найдем минимальную дату-время

        intervalWithMaxDate =
          !intervalWithMaxDate ||
          Date.parse(intervalWithMaxDate.end) <
            Date.parse(this.allRepairtimesOfOrder[i].interval.end)
            ? this.allRepairtimesOfOrder[i].interval
            : intervalWithMaxDate;
      }
      if (repairtime && repairtime.interval.id === intervalWithMaxDate.id) {
        //интервал repairtime не пересекается с другими интервалами
        return;
      }

      for (let i in this.allRepairtimesOfOrder) {
        if (
          i == 0 &&
          Date.parse(this.allRepairtimesOfOrder[i].interval.start) !=
            Date.parse(minDate)
        ) {
          let startDate = new Date(Date.parse(minDate));
          let endDate = new Date(startDate);
          endDate.setMinutes(
            startDate.getMinutes() +
              parseInt(this.allRepairtimesOfOrder[i].duration)
          );
          this.allRepairtimesOfOrder[i].interval.start =
            this.dateToTimestamp(startDate);
          this.allRepairtimesOfOrder[i].interval.end =
            this.dateToTimestamp(endDate);
        }
        if (i > 0 && this.allRepairtimesOfOrder[i].id == id) {
          this.allRepairtimesOfOrder[i].interval.start =
            this.allRepairtimesOfOrder[i - 1].interval.end;
          this.changeRepairtimeIntervalDate(
            this.allRepairtimesOfOrder[i].interval.start,
            this.allRepairtimesOfOrder[i]
          );
        }
        if (
          i > 0 &&
          Date.parse(this.allRepairtimesOfOrder[i].interval.start) <
            Date.parse(this.allRepairtimesOfOrder[i - 1].interval.end)
        ) {
          this.allRepairtimesOfOrder[i].interval.start =
            this.allRepairtimesOfOrder[i - 1].interval.end;
          this.changeRepairtimeIntervalDate(
            this.allRepairtimesOfOrder[i].interval.start,
            this.allRepairtimesOfOrder[i]
          );
        }
      }
    },
    showAttachDialogForExistEvent(event) {
      this.attachDialog.order = {};
      this.attachDialog.order.id = event.order_id;
      this.showAttachDialog();
      return;
    },
    startDrag(interval) {
      let start =
        typeof interval.event.start === "string"
          ? Date.parse(interval.event.start)
          : interval.event.start;
      if (interval && start > Date.now()) {
        this.dragInterval = interval;
        this.dragTime = null;
      }
    },
    startTime(tms) {
      const mouse = this.toTime(tms);
      if (this.dragInterval && this.dragTime === null) {
        const start = this.dragInterval.start;
        this.dragTime = mouse - start;
      }
    },
    mouseMove(tms) {
      const the_15_min_in_ms = 900000;
      const mouse = this.toTime(tms);
      let dateObj = new Date();
      let currentTimeZoneOffset = dateObj.getTimezoneOffset() * 60 * 60 * 20;
      const mouseRounded = this.roundTime(mouse + currentTimeZoneOffset, false);

      if (this.dragInterval && this.dragInterval.event) {
        //перетаскивание в календаре
        this.needSave = true;
        let start = this.$refs.calendar.timestampToDate(
          this.$refs.calendar.parseTimestamp(this.dragInterval.event.start)
        );
        let end = this.$refs.calendar.timestampToDate(
          this.$refs.calendar.parseTimestamp(this.dragInterval.event.end)
        );
        let duration = end - start;

        let startDate = this.$refs.calendar.timestampToDate(
          this.$refs.calendar.parseTimestamp(mouseRounded)
        );
        let endDate = this.$refs.calendar.timestampToDate(
          this.$refs.calendar.parseTimestamp(
            this.roundTime(mouseRounded + duration)
          )
        );
        if (!tms.future) {
          if(this.isShownErrorOnPastTime === false) {
            this.$store.dispatch("common/showError", {
              error: this.$t("viewCalendar.error_cant_choose_date_from_past"),
            });
            this.isShownErrorOnPastTime = true;
          }
          this.$store.dispatch("intervals/get", {
            date: this.currentCalendarDate,
          });
          return;
        } else {
          this.isShownErrorOnPastTime = false;
        }

        if (
          !this.hasRepairtimeOnPeriod(
            startDate,
            endDate,
            tms.category,
            this.dragInterval.event.order_id
          )
        ) {
          this.dragInterval.event.start = startDate;
          this.dragInterval.event.end = endDate;
          this.dragInterval.event.category = tms.category;
          this.dragInterval.event.post = this.posts.filter(
            (current) => current.name === tms.category
          )[0];
          this.intervals.forEach((interval) => {
            if (this.dragInterval.event.id === interval.id) {
              interval.start = startDate;
              interval.end = endDate;
              interval.post = this.posts.filter(
                (current) => current.name === tms.category
              )[0];
              interval.category = tms.category;
            }
          });
        }
      }
    },
    endDrag(tms) {
      let hasError = false;
      if (
        this.dragInterval &&
        this.dragInterval.event &&
        tms.future &&
        this.needSave
      ) {
        for(let i in this.intervals) {
            if (this.dragInterval.event.id === this.intervals[i].id) {
              if (this.intervals[i].post.active == 0) {
                hasError = true;
                this.$store.dispatch("intervals/get", {
                  date: this.currentCalendarDate,
                });

                this.$store.dispatch("common/showError", {
                  error: this.$t("viewCalendar.post_is_disabled"),
                });
              }

              if(!hasError) {
                //сохраним интервал
                this.$store.dispatch("intervals/update", this.intervals[i]).catch(() => {
                  this.$store.dispatch("intervals/get", {
                    date: this.currentCalendarDate,
                  });
                });
              }
            }

        }

        this.needSave = false;
      }

      this.dragTime = null;
      this.dragInterval = null;
    },
    cancelDrag() {
      this.dragTime = null;
      this.dragEvent = null;
    },
    hasRepairtimeOnPeriod(
      toDateStart,
      toDateEnd,
      postName,
      currentOrderItemId
    ) {
      return (
        this.allIntervals.filter((item) => {
          let item_start =
            typeof item.start === "string"
              ? Date.parse(item.start)
              : item.start;
          let item_end =
            typeof item.end === "string" ? Date.parse(item.end) : item.end;

          if (item.order_id === currentOrderItemId) return false; //если это текущий элемент
          if (item.category != postName) return false;
          if (
            item_start > Date.parse(toDateStart) &&
            item_start < Date.parse(toDateEnd)
          ) {
            return true;
          }
          if (
            (item_start > Date.parse(toDateStart) &&
              item_end <= Date.parse(toDateEnd)) ||
            (Date.parse(toDateStart) >= item_start &&
              Date.parse(toDateStart) < item_end)
          ) {
            return true;
          }
          return false;
        }).length > 0
      );
    },
    changeRepairtimeIntervalDate(startDate, repairtime) {
      repairtime.duration = Math.ceil(repairtime.duration / 15) * 15;
      startDate = new Date(Date.parse(startDate));
      let endDate = new Date(startDate);
      endDate.setMinutes(
        startDate.getMinutes() + parseInt(repairtime.duration)
      );
      repairtime.interval.start = this.dateToTimestamp(startDate);
      repairtime.interval.end = this.dateToTimestamp(endDate);
      this.recountIntervalDates(null, repairtime);
    },
    autofillEmptyRepairerInRepairtimes(data) {
      if (
        data &&
        this.order.items.filter((item) => {
          return (
            item.item_type === "repairtime" &&
            item.interval &&
            item.interval.repairer != null
          );
        }).length == 1
      ) {
        this.order.items.forEach((item) => {
          if (
            item.item_type === "repairtime" &&
            item.interval &&
            item.interval.repairer == null
          ) {
            item.interval.repairer = data;
          }
        });
      }
    },
    saveAttachedForOrderRepairtimesIntervals() {
      this.$store
        .dispatch("orders/ordersUpdate", this.order)
        .then((res) => {
          if (res) {
            this.findedOrders = [];
            this.order = {};
            this.attachDialog.hideAndClear();
            this.$store.dispatch("intervals/get", { date: this.calendarDate });
            this.$store.dispatch("posts/get");
          } else {
            this.showAttachDialog();
          }
        });
    },
    autocompleteItemText(item) {
      let date = this.$moment(item.created_at).format("DD.MM.YYYY HH:mm");
      return `#${item.human_number} (${this.formatCurrency(item.total_sum)})
      ${item.customer.last_name} ${item.customer.first_name} ${
        item.customer.patronymic ? item.customer.patronymic : ""
      } 
      [${date}]`;
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.calendarDate = this.todayDate;
    },

    selectedTimeIsUsed(dateStart, postName) {
      let dateStartObj = Date.parse(dateStart);
      return (
        this.allIntervals.filter((item) => {
          let item_start =
            typeof item.start === "string"
              ? Date.parse(item.start)
              : item.start;
          let item_end =
            typeof item.end === "string" ? Date.parse(item.end) : item.end;
          if (item.category != postName) return false;
          if (dateStartObj >= item_start && dateStartObj < item_end) {
            return true;
          }
          return false;
        }).length > 0
      );
    },
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
    roundTime(time, down = true) {
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    isDisabledPostByName(category) {
      return (
        this.posts.find((current) => current.name === category).active != 1
      );
    },
    selectTimeToAttachRepairtime(data) {
      if (this.dragInterval) return;
      if (this.isDisabledPostByName(data.category)) {
        //$t('viewCalendar.post_is_disabled')
        this.$store.dispatch("common/showError", {
          error: this.$t("viewCalendar.post_is_disabled"),
        });
        return;
      }
      let minutes = this.roundIntTo15(data.minute);
      let hour = minutes < 59 ? data.hour : data.hour + 1;
      let timeIsUsed = this.selectedTimeIsUsed(
        `${data.date} ${hour}:${minutes}:00`,
        data.category
      );
      if (!timeIsUsed && data.future) {
        this.attachDialog.date = data.date;
        this.attachDialog.time = `${hour}:${minutes}`;
        this.attachDialog.category = data.category;
        this.isFetchedOrder = true; //чтобы не видно было лоадер
        this.showAttachDialog();
      }
      if (!data.future && !timeIsUsed) {
        this.$store.dispatch("common/showError", {
          error: this.$t("viewCalendar.error_cant_choose_date_from_past"),
        });
      }
    },
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
  },
};
</script>

<style lang="css">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;
}

.v-calendar-category__columns
  .v-calendar-category__column:first-child
  .v-current-time.first::before {
  content: "";
  position: absolute;
  background-color: #ea4335;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: -5px;
  margin-left: -6.5px;
}

.past .eventWrap:hover {
  opacity: 0.9 !important;
  z-index: 100000;
}
.calendarIsLoading {
  opacity: 0.5;
}
.past .eventWrap {
  opacity: 0.5;
}
.eventWrap {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
.brandLogo {
  height: 18px;
  margin-top: 1px;
}
.v-calendar-daily_head-weekday {
  display: none !important;
}

/* drop target calendarDate and dragover state */
@keyframes nodeInserted {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 0.8;
  }
}

.item-dropzone-area {
  height: 2rem;
  background: #888;
  opacity: 0.8;
  animation-duration: 0.5s;
  animation-name: nodeInserted;
  margin-bottom: 1em;
  border-radius: 10px;
}
.v-event-timed {
  border-radius: 0 !important;
}
.v-event-timed:hover {
  z-index: 10000;
  height: auto !important;
  padding: 2px;
  width:inherit !important;
  min-width: 100%;
}
.custom-label .v-label {
  font-size: 12px;
}
.eventStatusColor {
  display: block;
  height: 8px;
  width: 8px;
  border: 1px solid white;
}
.v-event-timed .repairtimeName{white-space: normal;}
</style>
